import { render, staticRenderFns } from "./huotiStatistics.vue?vue&type=template&id=3fd3d55a&scoped=true&"
import script from "./huotiStatistics.vue?vue&type=script&lang=js&"
export * from "./huotiStatistics.vue?vue&type=script&lang=js&"
import style0 from "./huotiStatistics.vue?vue&type=style&index=0&id=3fd3d55a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd3d55a",
  null
  
)

export default component.exports